import React, { useEffect, useImperativeHandle, useRef } from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { useModel } from "../../../models";
import { Col, Form, Input, Modal, Row, Select,InputNumber} from "antd";
import {decoder,filterPayType} from "../../../utils/decoder"
const FillForm = ({ formRef }) => {
    const [{ selectedAccount,selectedCustomer}, { fillAccount, setFillModelVisible }] = useModel("customer");
    const [{ payTypeDict,accountTypeDict }, { getPayTypeDict }] = useModel("cmDict");
    const [form] = Form.useForm();
    useEffect(() => {
        getPayTypeDict();
    }, []);
    useEffect(() => {
        if(!!selectedAccount){
            form.setFieldsValue({...selectedCustomer,...selectedAccount});
            form.setFieldsValue({accountType:decoder(accountTypeDict,selectedAccount.accountType)})
        }

    }, [selectedAccount]);

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        fill: () => {
            // console.log(form.getFieldsValue());
            form.validateFields().then(datas => {
                let data = {
                    ...datas,
                    id:selectedAccount.id,
                    accountType:selectedAccount.accountType
                }
                fillAccount({ data }).then(() => {
                    setFillModelVisible(false);
                });

            })
        },
        reset: () => {
            form.resetFields();
        },
    }));
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{ span: 6 }}
            style={{ marginRight: "50px" }}
        >
                    <Form.Item
                        name="customerName"
                        label="客户名称"
                    >
                        <Input disabled={true} placeholder="客户名称" />
                    </Form.Item>
                    <Form.Item
                        name="accountType"
                        label="账户类型"
                        rules={[{ required: true, message: '账户类型是必选项', }]}
                    >
                        <Input disabled={true} placeholder="账户类型" />
                    </Form.Item>
                    <Form.Item
                        name="remainingAmount"
                        label="剩余金额"
                    >
                        <Input disabled={true} placeholder="剩余金额" />
                    </Form.Item>
                    <Form.Item
                        name="rechargeAmount"
                        label="充值金额"
                        rules={[{ required: true, message: '充值金额是必输项', }]}
                    >
                        <InputNumber placeholder="充值金额" />
                    </Form.Item>
                    <Form.Item
                        name="paymentMethod"
                        label="支付方式"
                        rules={[{ required: true, message: '充值方式是必输项', }]}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择支付方式"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={filterPayType(payTypeDict)}
                        />
                    </Form.Item>
                    <Form.Item
                        name="remarks"
                        label="备注"
                    >
                        <Input placeholder="备注" />
                    </Form.Item>
        </Form>
    )
}

export default function () {
    const [{ fillModelVisible, selectedAccount }, { setFillModelVisible }] = useModel("customer")

    const formRef = useRef();

    const onOk = () => {
        formRef.current.fill();
        // setFillModelVisible(false);
    }
    const onClose = () => {
        setFillModelVisible(false);
    }
    const Title = () => {
        return (
            <h3 style={{ flex: "1" }}>
                <OrderedListOutlined />
                <span className="margin-left-8">账户充值</span>
                <span className="margin-left-16">{selectedAccount.supplierName}-{selectedAccount.countTypeName}</span>
            </h3>
        )
    }

    return (
        <Modal
            title={<Title />}
            width={500}
            visible={fillModelVisible}
            onOk={onOk}
            onCancel={onClose}
        >
            <FillForm formRef={formRef} />
        </Modal>
    );
}